module.exports = __webpack_public_path__ + "img/telephone-fill.04daf7dc.svg";